import { fabric } from 'fabric';

let useFloatingControls = false;

export const enableFloatingControls = () => {
  useFloatingControls = true;
};

export const showMagicFrameCustomControls = () => {
  // If floating controls are enabled, don't show the old controls
  if (useFloatingControls) {
    if (fabric.MagicFrame.prototype.controls.replacePhoto) {
      fabric.MagicFrame.prototype.controls.replacePhoto.setVisibility(false);
    }
    if (fabric.MagicFrame.prototype.controls.modifyPhoto) {
      fabric.MagicFrame.prototype.controls.modifyPhoto.setVisibility(false);
    }
    return;
  }

  // Original behavior
  fabric.MagicFrame.prototype.controls.replacePhoto.setVisibility(true);
  fabric.MagicFrame.prototype.controls.modifyPhoto.setVisibility(true);
};
